import { HubPageSection } from "@hub/hub/components/hub-page";
import { HeadMetadata } from "@hub/models/metadata/head-metadata";
import { BannerConfig } from "@hub/models/ui/banner-config";
import { Breadcrumb } from "@hub/models/ui/breadcrumb";
import { Card as ICard } from "@hub/models/ui/card";
import { PageConfig } from "@hub/models/ui/page-config";
import { Auth0Header } from "@hub/ui/auth0/auth0-header";
import { ResourcesBanner } from "@hub/ui/banners/resources-banner";
import { Breadcrumbs } from "@hub/ui/breadcrumbs/breadcrumbs";
import { CardPanel } from "@hub/ui/cards/card-panel";
import { SignUpCard } from "@hub/ui/cards/home/sign-up-card";
import { NewCard } from "@hub/ui/cards/new-card";
import { ShellLayout } from "@hub/ui/layouts/shell-layout";
import React from "react";

interface GetStartedPageProps {
  breadcrumbs?: Breadcrumb[];
  headMetadata?: HeadMetadata;
  pageConfig: PageConfig;
  bannerConfig: BannerConfig;
  cardData: ICard[];
}

export const GetStartedPage: React.FC<GetStartedPageProps> = ({
  breadcrumbs,
  headMetadata,
  pageConfig,
  bannerConfig,
  cardData,
}) => {
  const colors = ["emerald", "magenta", "indigo", "yellow"];

  return (
    <ShellLayout
      header={<Auth0Header />}
      pageConfig={pageConfig}
      headMetadata={headMetadata}
      banner={
        <ResourcesBanner
          title={bannerConfig.title}
          description={bannerConfig.description}
        />
      }
      breadcrumbs={
        breadcrumbs ? <Breadcrumbs breadcrumbs={breadcrumbs} /> : null
      }
      page={
        <>
          <CardPanel type="additional">
            {cardData.map((cardProps, index) => {
              return (
                <NewCard
                  key={cardProps.title}
                  title={cardProps.title}
                  description={cardProps.description}
                  link={cardProps.link}
                  illustration={cardProps.illustration}
                  theme="light"
                  highlight={colors[index] || "emerald"}
                />
              );
            })}
          </CardPanel>
          <HubPageSection />
          <SignUpCard />
        </>
      }
    />
  );
};
